// TODO: move cart drawer footer with business logic from CartDrawer.js
export function CartDrawerFooter({ footer }) {
  return footer;
}
